// Configuración centralizada de URLs de API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const BACKEND_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';

export { API_BASE_URL, BACKEND_URL };
